import { type PropsWithChildren } from "react";
import { NotificationCheckBox } from "../atoms/notification-check-box";
import { Link } from "react-router";
import css from "./notification-item.scss";

export const NotificationRow = ({ children }: PropsWithChildren): JSX.Element => {
    return <div className={css.notificationItem__row}>{children}</div>;
};

export type NotificationItemProps = {
    markRead?: () => void;
};

export const NotificationCard = ({
    children,
    markRead,
}: PropsWithChildren<NotificationItemProps>): JSX.Element => {
    return (
        <div className="flex p-2.5 hover:bg-gray-100">
            <div className="grow overflow-hidden whitespace-nowrap">{children}</div>
            <div className="flex grow justify-end self-center px-2">
                {markRead && <NotificationCheckBox hover onClick={markRead} />}
            </div>
        </div>
    );
};

export interface NotificationTitleProps {
    to: string;
}

export const NotificationTitle = ({
    children,
    to,
}: PropsWithChildren<NotificationTitleProps>): JSX.Element => {
    return (
        <Link to={to} className={css.notificationItem__title}>
            {children}
        </Link>
    );
};

export const NotificationLink = ({
    children,
    to,
}: PropsWithChildren<NotificationTitleProps>): JSX.Element => {
    return (
        <Link to={to} className={css.notificationItem__link}>
            {children}
        </Link>
    );
};
